import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import ChatPanel from '../chat/ChatPanel'
import { useAuthStore } from '../../store/authStore'
import { connectSocket } from '../../socket/socketClient'

export default function AppLayout() {
  const { user } = useAuthStore()
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    if (user) {
      connectSocket()
    }
  }, [user])

  // Referme le menu mobile à chaque changement de route
  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  // Referme le menu mobile avec la touche Échap
  useEffect(() => {
    if (!sidebarOpen) return
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') setSidebarOpen(false) }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [sidebarOpen])

  return (
    <div className="app">
      <Sidebar open={sidebarOpen} />
      <TopBar sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen(o => !o)} />
      {sidebarOpen && (
        <div
          className="sidebar-backdrop open"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
      <main className="main">
        <Outlet />
      </main>
      <ChatPanel />
    </div>
  )
}
